module.exports = __webpack_public_path__ + "static/img/al5.d9b08f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/al5.jpg
// module id = loEU
// module chunks = 0